import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const RestroomMen = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="RestroomMen" {...props}>
    <path d="M13.0006 6C13.2391 6.00014 13.4699 6.08599 13.651 6.24121L20.651 12.2412C21.0698 12.6006 21.1184 13.2312 20.7594 13.6504C20.4001 14.0696 19.7686 14.1179 19.3492 13.7588L14.1569 9.30664L14.9987 21.9336C15.0353 22.4844 14.6177 22.961 14.067 22.998C13.516 23.0347 13.0393 22.6174 13.0026 22.0664L12.5319 15H11.4694L10.9987 22.0664C10.9619 22.6172 10.485 23.0344 9.9342 22.998C9.38319 22.9613 8.9659 22.4846 9.00256 21.9336L9.84338 9.30664L4.651 13.7588C4.23177 14.1181 3.60129 14.0694 3.24182 13.6504C2.8824 13.2311 2.93089 12.6006 3.35022 12.2412L10.3502 6.24121L10.4196 6.18555C10.5884 6.06522 10.7918 6 11.0006 6H13.0006ZM12.0006 1C13.1049 1.00032 14.0006 1.89563 14.0006 3C14.0006 4.10437 13.1049 4.99968 12.0006 5C10.896 5 10.0006 4.10457 10.0006 3C10.0006 1.89543 10.896 1 12.0006 1Z" fill="#000" />
  </StyledIcon>
));

RestroomMen.displayName = 'RestroomMen';

export { RestroomMen };
